<div class="share-wrapper">
  <div class="cnt-button-secondary w-button">Share this property</div>
  <div class="share-icon-wrapper">
    <button type="button" class="icon" shareButton="facebook">
      <div class="w-embed">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          xml:space="preserve"
        >
          <style type="text/css">
            .share-fill {
              fill: #454545;
            }
          </style>
          <path
            class="share-fill"
            d="M12,0C5.4,0,0,5.4,0,12.1c0,6,4.4,11,10.2,11.9v-8.4H7.1v-3.5h3.1V9.4c0-3,1.8-4.7,4.6-4.7
C16,4.7,17.4,5,17.4,5v3h-1.5c-1.5,0-2,0.9-2,1.9v2.3h3.3l-0.5,3.5h-2.8V24c5.9-0.9,10.2-6,10.2-11.9C24,5.4,18.6,0,12,0z"
          ></path>
        </svg>
      </div>
    </button>
    <button type="button" class="icon share" shareButton="twitter">
      <div class="w-embed">
        <svg
          version="1.1"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          xml:space="preserve"
        >
          <style type="text/css">
            .share-fill {
              fill: #454545;
            }
          </style>
          <path
            class="share-fill"
            d="M459.4,151.7c0.3,4.5,0.3,9.1,0.3,13.6c0,138.7-105.6,298.6-298.6,298.6c-59.5,0-114.7-17.2-161.1-47.1
c8.4,1,16.6,1.3,25.3,1.3c49.1,0,94.2-16.6,130.3-44.8c-46.1-1-84.8-31.2-98.1-72.8c6.5,1,13,1.6,19.8,1.6c9.4,0,18.8-1.3,27.6-3.6
c-48.1-9.7-84.1-52-84.1-103v-1.3c14,7.8,30.2,12.7,47.4,13.3c-28.3-18.8-46.8-51-46.8-87.4c0-19.5,5.2-37.4,14.3-53
c51.7,63.8,129.3,105.4,216.4,110c-1.6-7.8-2.6-15.9-2.6-24c0-57.8,46.8-104.9,104.9-104.9c30.2,0,57.5,12.7,76.7,33.1
c23.7-4.5,46.5-13.3,66.6-25.3c-7.8,24.4-24.4,44.8-46.1,57.8c21.1-2.3,41.6-8.1,60.4-16.2C497.7,118.3,479.8,136.8,459.4,151.7
L459.4,151.7z"
          ></path>
        </svg>
      </div>
    </button>
  </div>
</div>
